import { horizontalDividerBlock } from '../common'
import type { ImpactSolutionType, ImpactSummaryType } from '~/types/types'
import { ImpactSolutionKind } from '~/types/types'
import { roundValue } from '~/functions/ghg'

const impactSolutionKindMapper = {
  [ImpactSolutionKind.Product]: "Product",
  [ImpactSolutionKind.Service]: "Service",
  [ImpactSolutionKind.Hybrid]: 'Product/Service',
  'fallback': 'N/A'
}
const impactSolutionKindSvgMapper = {
  [ImpactSolutionKind.Product]: `<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="#8FA5AF" d="M21 16.5c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18s-.41-.06-.57-.18l-7.9-4.44A.99.99 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18s.41.06.57.18l7.9 4.44c.32.17.53.5.53.88zM12 4.15L6.04 7.5L12 10.85l5.96-3.35zM5 15.91l6 3.38v-6.71L5 9.21zm14 0v-6.7l-6 3.37v6.71z"/></svg>`,
  [ImpactSolutionKind.Service]: `<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="#8FA5AF" d="M10 4a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4m0 2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m7 6q-.24 0-.24.24l-.26 1.26c-.22.18-.54.34-.78.5l-1.28-.5c-.08 0-.24 0-.32.1l-.96 1.76c-.08.08-.08.24.08.32l1.04.82v1l-1.04.82c-.08.08-.16.24-.08.32l.96 1.76c.08.1.24.1.32.1l1.28-.5c.24.16.56.32.78.5l.26 1.26q0 .24.24.24h2c.08 0 .24-.08.24-.24l.16-1.26c.32-.18.64-.34.88-.5l1.22.5c.14 0 .3 0 .3-.1l1.04-1.76c.08-.08 0-.24-.08-.32l-1.04-.82v-1l1.04-.82c.08-.08.16-.24.08-.32L21.8 13.6c0-.1-.16-.1-.3-.1l-1.22.5c-.24-.16-.56-.32-.88-.5l-.16-1.26c0-.16-.16-.24-.24-.24zm-7 1c-2.67 0-8 1.33-8 4v3h9.67c-.28-.59-.48-1.23-.58-1.9H3.9V17c0-.64 3.13-2.1 6.1-2.1c.43 0 .87.04 1.3.1c.2-.64.47-1.24.82-1.79c-.78-.13-1.52-.21-2.12-.21m8.04 2.5c.8 0 1.46.66 1.46 1.54c0 .8-.66 1.46-1.46 1.46c-.88 0-1.54-.66-1.54-1.46c0-.88.66-1.54 1.54-1.54"/></svg>`,
  [ImpactSolutionKind.Hybrid]: `<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="#8FA5AF" d="M12 6v3l4-4l-4-4v3a8 8 0 0 0-8 8c0 1.57.46 3.03 1.24 4.26L6.7 14.8A5.9 5.9 0 0 1 6 12a6 6 0 0 1 6-6m6.76 1.74L17.3 9.2c.44.84.7 1.8.7 2.8a6 6 0 0 1-6 6v-3l-4 4l4 4v-3a8 8 0 0 0 8-8c0-1.57-.46-3.03-1.24-4.26"/></svg>`,
  'fallback': 'N/A'
}

export const handleImpactSolutions = (
  impactSummary: ImpactSummaryType,
  // impactSolutions: ImpactSolutionType[],
  _locale: string,
) => {
  return [
    horizontalDividerBlock(),
    {
      text: 'Our solutions',
      width: '*',
      style: ['blueHeader'],
    },
    ...[
      impactSummary?.impactSolutionSummaries?.map((solutionSummary) => {
        const evidenceLinks = (solutionSummary?.impactSolution as any)?.evidenceLinks || []
        return [
          horizontalDividerBlock(),
          {
            columns: [
              {
                margin: [12, 0, 0, 0],
                columns: [
                  {
                    svg: `<svg width="21" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 11h3v2h-3zM1 11h3v2H1zM13 1v3h-2V1zM4.92 3.5l2.13 2.14l-1.42 1.41L3.5 4.93zm12.03 2.13l2.12-2.13l1.43 1.43l-2.13 2.12zM12 6a6 6 0 0 1 6 6c0 2.22-1.21 4.16-3 5.2V19a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-1.8c-1.79-1.04-3-2.98-3-5.2a6 6 0 0 1 6-6m2 15v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1zm-3-3h2v-2.13c1.73-.44 3-2.01 3-3.87a4 4 0 0 0-4-4a4 4 0 0 0-4 4c0 1.86 1.27 3.43 3 3.87z" fill="#5188ff"/>
                    </svg>`,
                    margin: [0,0,0,10],
                    width: 20,
                    height: 20,
                  },
                                      {
                      text: solutionSummary?.impactSolution?.concept?.label || 'N/A',
                      margin: [-20, 6, 0, 0],
                      style: ['blueTextMedium'],
                    }
                ],
              },
            ]
          },
          {
            margin: [15, 8, 0, 0],
            text: solutionSummary?.impactSolution?.solutionDescription || 'N/A',
            style: 'message',
          },
          {
            margin: [15, 8, 0, 0],
            columns: [
              [
                // CUBE
                {
                  columns: [
                    {
                      svg: impactSolutionKindSvgMapper[solutionSummary?.impactSolution?.kind ?? ImpactSolutionKind.Hybrid],
                      width: 15,
                      height: 15,
                      margin: [0, 3, 0, 0],
                    },
                    {
                      text: impactSolutionKindMapper[solutionSummary?.impactSolution?.kind ?? ImpactSolutionKind.Hybrid],
                      style: ['message'],
                      margin: [-20, 6, 0, 0],
                    },
                  ],
                },
              ],
              [
                // GROUP
                {
                  columns: [
                    {
                      svg: `<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="#8FA5AF" d="M12 5.5A3.5 3.5 0 0 1 15.5 9a3.5 3.5 0 0 1-3.5 3.5A3.5 3.5 0 0 1 8.5 9A3.5 3.5 0 0 1 12 5.5M5 8c.56 0 1.08.15 1.53.42c-.15 1.43.27 2.85 1.13 3.96C7.16 13.34 6.16 14 5 14a3 3 0 0 1-3-3a3 3 0 0 1 3-3m14 0a3 3 0 0 1 3 3a3 3 0 0 1-3 3c-1.16 0-2.16-.66-2.66-1.62a5.54 5.54 0 0 0 1.13-3.96c.45-.27.97-.42 1.53-.42M5.5 18.25c0-2.07 2.91-3.75 6.5-3.75s6.5 1.68 6.5 3.75V20h-13zM0 20v-1.5c0-1.39 1.89-2.56 4.45-2.9c-.59.68-.95 1.62-.95 2.65V20zm24 0h-3.5v-1.75c0-1.03-.36-1.97-.95-2.65c2.56.34 4.45 1.51 4.45 2.9z"/></svg>`,
                      width: 15,
                      height: 15,
                      margin: [0, 3, 0, 0],
                    },
                    {
                      text: solutionSummary?.impactSolution?.targetGroup || 'N/A',
                      style: ['message'],
                      margin: [-20, 7, 0, 0],
                    },
                  ],
                },
              ],
              [
                // BULLSEYE
                {
                  columns: [
                    {
                      svg:  `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 0a12 12 0 1 0 12 12c0-1.392-.252-2.772-.732-4.068l-1.92 1.92c.168.708.252 1.428.252 2.148A9.6 9.6 0 1 1 12 2.4c.72 0 1.44.084 2.148.252L16.08.72A12.1 12.1 0 0 0 12 0m8.4 0-4.8 4.8v1.8l-3.06 3.06c-.18-.06-.36-.06-.54-.06a2.4 2.4 0 1 0 2.4 2.4c0-.18 0-.36-.06-.54L17.4 8.4h1.8L24 3.6h-3.6zM12 4.8a7.2 7.2 0 1 0 7.2 7.2h-2.4A4.8 4.8 0 1 1 12 7.2z" fill="#8FA5AF"/></svg>`,
                      width: 15,
                      height: 15,
                      margin: [0, 3, 0, 0],
                    },
                    {
                      text: solutionSummary?.impactConcept || 'N/A',
                      style: ['message'],
                      margin: [-20, 6, 0, 0],
                    },
                  ],
                },
              ],
              [
                //GLOBE
                solutionSummary?.totalGhgReduction != 'N/A'  ? [{
                  columns: [
                    {
                      svg: `<svg width="21" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.9 17.39c-.26-.8-1.01-1.39-1.9-1.39h-1v-3a1 1 0 0 0-1-1H8v-2h2a1 1 0 0 0 1-1V7h2a2 2 0 0 0 2-2v-.41a7.984 7.984 0 0 1 2.9 12.8M11 19.93c-3.95-.49-7-3.85-7-7.93c0-.62.08-1.22.21-1.79L9 15v1a2 2 0 0 0 2 2m1-16A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2" fill="#8FA5AF"/></svg>`,
                      width: 15,
                      height: 15,
                      margin: [0, 3, 0, 0],
                    },
                    {
                      text: `Planned reductions of ${roundValue(solutionSummary.totalGhgReduction)} tons CO2e over 5 years`,
                      style: ['message'],
                      margin: [-20, 6, 0, 0],
                    },
                  ],
                }] : [],
              ],
            ],
          },
          ...buildEvidenceContent(evidenceLinks),
        ]
      }),
    ],
    horizontalDividerBlock(30, 770, [-5, 12, 0, 0]),
  ]
}

const buildEvidenceContent = (evidenceLinks: any[]) => {
  if (!evidenceLinks?.length) return []
  return [
    {
      margin: [15, 8, 0, 0],
      columns: [
        {
          text: 'Evidence',
          style: ['sectionLabel'],
        },
      ],
    },
    ...evidenceLinks.map((evidenceLink) => {
      const fileUrl = evidenceLink?.evidence?.internalUrl || evidenceLink?.evidence?.websiteUrl || ''
      const fileName = evidenceLink?.evidence?.filename || fileUrl || 'Evidence'
      const websiteUrl = evidenceLink?.evidence?.websiteUrl || ''
      return {
        margin: [15, 4, 0, 0],
        columns: [
          {
            width: '30%',
            stack: [
              { text: 'Description', style: ['messageBold'] },
              { text: evidenceLink?.description || '-', style: ['message'] },
            ],
          },
          {
            width: '70%',
            stack: [
              { text: evidenceLink?.evidence?.description || fileName, style: ['messageBold'] },
              ...(fileUrl
                ? [{
                    text: `File: ${fileName}`,
                    style: ['blueTextSmall'],
                    link: fileUrl,
                  }]
                : []),
              ...(websiteUrl && websiteUrl !== fileUrl
                ? [{
                    text: `URL: ${websiteUrl}`,
                    style: ['blueTextSmall'],
                    link: websiteUrl,
                  }]
                : []),
            ],
          },
        ],
      }
    }),
  ]
}
